import { Classes, CollapsibleList, IMenuItemProps, MenuItem } from "@blueprintjs/core";
import classNames from "classnames";
import Loading from "common/fragments/Loading";
import VerticalCenter from "common/fragments/VerticalCenter";
import { BlockVariant, BlockView } from "common/views/block/BlockView.view";
import { CardView } from "common/views/card/Card.view";
import IconView from "common/views/icon/Icon.view";
import { ImageVariant, ImageView } from "common/views/image/Image.view";
import { IPanelProps, Panel } from "core/decorators/Panel";
import { isEmpty } from "core/util/ArrayUtils";
import React from "react";
import styled from "styled-components";
import { CourseWrapper } from "../../common/entities/courseWrapper/CourseWrapper";
import HeadingView, { HeadingVariant } from "../../common/views/heading/Heading.view";
import PageLinkView from "../../common/views/pageLink/PageLink.view";
import { RowsView } from "../../common/views/rows/Rows.view";
import FetchResolverService from "../../core/service/resolver/impl/FetchResolver.service";
import ServiceRegistry from "../../core/util/ServiceRegistry";
import Config from "./Config";
import ProgramTrackProduct from "./entities/ProgramTrackProduct";
import labelProvider from './ProgramTrackProducts.labels';

interface ITrackProductParams {
	programTrackName?: string;
	programTrackId?: number;
}

const resolverService = ServiceRegistry.get(FetchResolverService);
const { Labels } = labelProvider;
// const TrackProductQuery = Query.queryMany<ProgramTrackProduct, ITrackProductParams>(ProgramTrackProduct);

interface IProgramTrackProductsState {
	data: any;
	loading: boolean;
}

const query = ({name}) => `
	{
	  entities: programTrackProducts(params: {programTrackName: "${name}"}) {
		id
		entry {
		  id
		  startDate
		  endDate
		  launchURL {
			viewURL
			launchURL
			cartURL
		  }
		  displayName
		  product {
			name
			subTitle
			description
			shortDescription
			iconURL
			smallIconURL
		  }
		}
		programTrack {
		  id
		  name
		  description
		}
	  }
	}
`;

const StyledThumbnailOverlay = styled(VerticalCenter)`
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	transition: 0.1s;
	opacity: 0;
	color: #fff;
	&:hover {
		background-color: rgba(0,0,0,0.4);
		opacity: 1;
	}
`;

@Panel({id: "program-track-products", configClass: Config, pageParams: true, labelProvider})
export default class ProgramTrackProductsPanel extends React.PureComponent<IPanelProps<Config>, IProgramTrackProductsState> {

	constructor(props: IPanelProps<Config>) {
		super(props);

		this.state = {loading: true, data: null};
	}

	private renderBreadcrumb(props: IMenuItemProps) {
		if (typeof props.href !== "string") {
			return <a className={Classes.BREADCRUMB}>{props.text}</a>;
		} else {
			return <span className={classNames(Classes.BREADCRUMB, Classes.BREADCRUMB_CURRENT)}>{props.text}</span>;
		}
	}

	public componentDidMount() {
		const { trackName } = this.props.pageParams;

		return resolverService.execute(query, {name: trackName}).then((response) => {
			return response.json();
		}).then((data) => (
			data.data.entities
		)).then((data: any) => {
			if(data) {
				this.setState({data, loading: false});
			} else {
				this.setState({loading: false});
			}
		});
	}

	public render() {
		const { data, loading } = this.state;
		const { trackName } = this.props.pageParams;

		if(loading) {
			return <Loading />;
		}

		if(!trackName) {
			return "Please select a program track.";
		}

		return (
			<div>
				<CollapsibleList
					className={Classes.BREADCRUMBS}
					dropdownTarget={<span className={Classes.BREADCRUMBS_COLLAPSED} />}
					visibleItemRenderer={this.renderBreadcrumb}
				>
					<MenuItem icon="folder-close" text={
						<PageLinkView viewKey="breadcrumb.home">
							<Labels.BreadcrumbHome/>
						</PageLinkView>
					} />

					<MenuItem icon="folder-close" text={
						<PageLinkView viewKey="breadcrumb.program">
							{/* <Label k="breadcrumb-home">FP&amp;A</Label> */}
							FP &amp; A
						</PageLinkView>
					} />

					<MenuItem icon="document" text={trackName} />
				</CollapsibleList>


				<HeadingView variant={HeadingVariant.H1} viewKey={"program.name"}>
					{trackName}
				</HeadingView>

				{!isEmpty(data) && (
					<React.Fragment>
						{data[0].programTrack && (
							<HeadingView viewKey={"program.description"}>
								{data[0].programTrack.description}
							</HeadingView>
						)}

						<div>
							<RowsView viewKey="rows">
								{data.map(this.renderProduct)}
							</RowsView>
						</div>
					</React.Fragment>
				)}
			</div>
		);
	}

	private renderProduct = (trackProduct: ProgramTrackProduct) => {
		const w = CourseWrapper.forEntry(trackProduct.entry);

		return (
			<CardView viewKey="card">
				<div style={{position: "relative"}}>
					<ImageView variant={ImageVariant.THUMBNAIL} src={w.getIconUrl()} viewKey="thumbnail" />
					{
						w.isLaunchable() && (
							<StyledThumbnailOverlay onClick={() => w.launchCourse()}>
								<IconView icon="play" viewKey="course-play-icon" />
							</StyledThumbnailOverlay>
						)
					}
				</div>
				<BlockView variant={BlockVariant.CARD_CONTENT} viewKey="card-primary">
					<HeadingView  viewKey="course-title" />
				</BlockView>
			</CardView>
		);
	}
}



// WEBPACK FOOTER //
// ./src/panels/programTrackProducts/ProgramTrackProducts.panel.tsx